import { useTranslation } from 'react-i18next';

import { Button } from '@components';
import { SCREEN_BREAKPOINTS } from '@constants';
import { Translation } from '@enums';
import { useMediaQuery } from '@hooks';

export const SettingsButtons = ({ handleSaveModal, isLoading }: any) => {
  const { t: tConfigurationButton } = useTranslation(Translation.Configuration, { keyPrefix: 'buttons' });

  const isAboveSm = useMediaQuery(`(min-width: ${SCREEN_BREAKPOINTS.sm}px)`);

  return (
    <div className="flex gap-4 flex-1 items-end sm:flex-none">
      <Button fullWidth={!isAboveSm} onClick={handleSaveModal} loading={isLoading} disabled={false}>
        {tConfigurationButton('saveSettings')}
      </Button>
    </div>
  );
};
